import { render, staticRenderFns } from "./TheCreditsInfo.vue?vue&type=template&id=69b7a596&scoped=true"
import script from "./TheCreditsInfo.vue?vue&type=script&lang=js"
export * from "./TheCreditsInfo.vue?vue&type=script&lang=js"
import style0 from "./TheCreditsInfo.vue?vue&type=style&index=0&id=69b7a596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7a596",
  null
  
)

export default component.exports